import { InspectionTaskStatus } from '@euler/model/enum';
import { TaskListItem } from '@euler/model/TaskListItem';
import { taskListItemFromTask } from '@euler/model/util';
import { TaskService } from '@euler/services/task.service';

const kPageSize = 50;
// A store's open orders are dozens; this only stops a runaway loop.
const kMaxTasks = 500;

/** Every open main task of the store, newest first. */
export async function fetchUnfinishedTasks(
  taskService: TaskService,
): Promise<TaskListItem[]> {
  // By id: a task opened between two pages pushes the list down, and the
  // next page starts with the last one again.
  const tasks = new Map<string, TaskListItem>();
  for (let offset = 0; ; offset += kPageSize) {
    if (offset >= kMaxTasks) {
      console.error(`workshop board: more than ${kMaxTasks} open tasks`);
      break;
    }
    const page = await taskService.list(
      {
        status: [InspectionTaskStatus.Pending, InspectionTaskStatus.InProgress],
      },
      offset,
      kPageSize,
      'createdAt',
      'desc',
    );
    for (const task of page) tasks.set(task.taskNo, taskListItemFromTask(task));
    if (page.length < kPageSize) break;
  }
  return [...tasks.values()];
}
